import React from 'react';
// material
import { Box, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
// ----------------------------------------------------------------------

const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    opacity: 0.5,
    transition: "opacity .15s linear",
    '&:hover':{
      opacity: 1,
    }
  }
}));

export default function GsgroupLogo() {
  const src = 'https://onegsgroup.com/images/gsgroup-logo.png';

  const classes = useStyles();

  const onClick = () => {
    window.open('https://onegsgroup.com', '_blank');
  }

  return (
    <Box onClick={onClick}>
      <img
        src={src}
        className={classes.logo}
        width="100%" height="100%"
      />
    </Box>
  );
}
